module.exports = __webpack_public_path__ + "static/energy_private_4-5e61815acaa36f6458299351d9f4d39d.jpg";